// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LabelSchema } from './v1/labelSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const getTagPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Label ID"),
});

export const getTagHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Label retrieved successfully
 */
export const getTag200Schema = z.lazy(() => v1LabelSchema);

/**
 * @description Label not found
 */
export const getTag404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const getTagQueryResponseSchema = z.lazy(() => getTag200Schema);
